import { render, staticRenderFns } from "./catalog.vue?vue&type=template&id=ef469ede&scoped=true&lang=pug"
import script from "./catalog.vue?vue&type=script&lang=js"
export * from "./catalog.vue?vue&type=script&lang=js"
import style0 from "./catalog.vue?vue&type=style&index=0&id=ef469ede&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef469ede",
  null
  
)

export default component.exports